// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"950be2a6","453":"639f9b37","667":"3d88b0e7","946":"4078cba1"}[chunkId] + ".chunk.js";
};